"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.egressSpiClient = void 0;
require("@redbox-ruby/data-lib");
const data_lib_1 = require("@redbox-ruby/data-lib");
function egressSpiClient(networkClient) {
    return {
        sendEgressCampaign: (message) => {
            networkClient.fireToTopic(data_lib_1.EGRESS_TOPIC, message, "Unable to send egress campaign message, error=");
        },
        sendEgressTeam: (message) => {
            networkClient.fireToTopic(data_lib_1.EGRESS_TOPIC, message, "Unable to send egress team message, error=");
        },
    };
}
exports.egressSpiClient = egressSpiClient;
